import React, { useEffect, useMemo, useState } from "react";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../../styles.css";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../../loading";
import { useTranslation } from "react-i18next";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import { useSelector } from "react-redux";
import CustomPagination from "../../CustomWidgets/CustomPagination";


const ProductPurchaseDetails = ({ additionalData ,pagination }) => {
  const { t, i18n } = useTranslation();
  const [flag, setFlag] = useState(false);

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  );

  const data = useMemo(
    () =>
      additionalData?.status
        ? additionalData?.all_product
        : additionalData || [],
    [additionalData]
  );

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setFlag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);

  const formatNumber = (val, showCurrency, currency) => {
  const num = Number(val);

  // covers NaN, null, undefined, "", non-numeric
  if (!isFinite(num)) return "-";

  const hasDecimal = num % 1 !== 0;

  const formatted = hasDecimal ? num.toFixed(2) : num.toString();

  return showCurrency ? `${currency} ${formatted}` : formatted;
};

const columns = useMemo(() => {
  const baseColumns = [
    {
      Header: (
        <div className="text-start justify-start" title={t("Purchase Date")}>
          {t("Date & Time")}
        </div>
      ),
      accessor: "date",
      headerClassName: "text-start",
      Cell: ({ row }) => (
        <div className="text-start justify-start">
          {row.original.date}
        </div>
      ),
    },
    {
        Header: <div className="text-start">{t("User")}</div>,
        accessor: "user_name",
        Cell: ({ row }) => (
          <div className="text-start">
            {row.original.user_name}
          </div>
        ),
      },
       {
        Header: <div className="text-start">{t("Vendor")}</div>,
        accessor: "vendor_name",
        Cell: ({ row }) => (
          <div className="text-start">
            {row.original.vendor_name || '-'}
          </div>
        ),
      },
    {
      Header: (
        <div className="text-start" title={t("Transaction Type")}>
          {t("Transaction Type")}
        </div>
      ),
      accessor: "transaction_type",
      headerClassName: "text-start",
      Cell: ({ row }) => (
        <div className="text-start">
          {t(row.original.transaction_type)}
        </div>
      ),
    },
    {
      Header: (
        <div className="text-start" title={t("Transaction ID")}>
          {t("Transaction ID")}
        </div>
      ),
      accessor: "transaction_id",
      Cell: ({ row }) => (
        <div className="text-start">
          {row.original.transaction_id}
        </div>
      ),
    },
    {
      Header: (
        <div className="text-start" title={t("Sale Price")}>
          {t("Sale Price")}
        </div>
      ),
      accessor: "sale_price",
      Cell: ({ row }) => (
        <div className="text-start">
          {`EGP ${row.original.sale_price?.toFixed(2)}`}
        </div>
      ),
    },
    {
      Header: (
        <div className="text-start" title={t("Cost Price")}>
          {t("Purchase Price")}
        </div>
      ),
      accessor: "purchase_price",
      Cell: ({ row }) => (
        <div className="text-start justify-start">
          {`EGP ${row.original.purchase_price?.toFixed(2)}`}
        </div>
      ),
    },
    {
      Header: (
        <div className="text-start" title={t("Quantity")}>
          {t("Quantity")}
        </div>
      ),
      accessor: "qty",
      Cell: ({ row }) => (
        <div className="text-start justify-start">
          {formatNumber(row.original.qty, false)}
        </div>
      ),
    },
  ];

  if (allStores) {
    baseColumns.splice(1, 0, // insert after Date column
      {
        Header: <div className="text-start">{t("Store")}</div>,
        accessor: "store_name",
        Cell: ({ row }) => (
          <div className="text-start">
            {row.original.store_name}
          </div>
        ),
      },
      
    );
  }

  return baseColumns;
}, [allStores, t]);

 const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  const [pageIndex, setpageIndex] = useState(1);
  
      useEffect(() => {
          const pageDetails = {
              limit: pageSize,
              offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
          };
  
          if (pageSize) pagination(pageDetails);
      }, [pageSize, pageIndex]);

  return (
    <>
      <div
        className="container flex flex-col mx-auto ms-4 mb-6 mt-4"
        style={{ maxWidth: "100%" }}
      >
        {additionalData?.length === 0 && flag === false ? (
          <div className="h-screen w-[90%] mt-2 ms-4">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            <div>
                        <table
                          className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                          style={{ tableLayout: "fixed" }}
                        >
                          <thead>
                            {headerGroups.map((headerGroup, headerIndex) => {
                              const { key: headerKey, ...headerGroupProps } =
                                headerGroup.getHeaderGroupProps();
                              return (
                                <tr
                                  key={headerKey}
                                  {...headerGroupProps}
                                  className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                                >
                                  {headerGroup.headers.map((column, colIndex) => {
                                    const { key: columnKey, ...columnProps } =
                                      column.getHeaderProps(
                                        column.getSortByToggleProps()
                                      );
                                    return (
                                      <th
                                        key={columnKey}
                                        {...columnProps}
                                        className="py-3 whitespace-nowrap"
                                        style={{ width: column.width }} // Set column width
                                      >
                                        <div className="flex items-start ms-2 text-sm ">
                                          {column.render("Header")}
                                          <span className="">
                                            {column.isSorted ? (
                                              column.isSortedDesc ? (
                                                <img
                                                  src={Vectorsorting}
                                                  style={{ minHeight: 10, minWidth: 10 }}
                                                  alt="vector"
                                                />
                                              ) : (
                                                <img
                                                  className="rotate-180"
                                                  src={Vectorsorting}
                                                  alt="vector"
                                                />
                                              )
                                            ) : (
                                              ""
                                            )}
                                          </span>
                                        </div>
                                      </th>
                                    );
                                  })}
                                </tr>
                              );
                            })}
                          </thead>
                        </table>
                      </div>
          
                      {/* Body Table (Scrollable) */}
                      <div
                        className="scrollbar-none bg-white"
                        style={{
                          overflowY: "auto",
                          maxHeight: "450px", // Adjust height as needed
                        }}
                      >
                        <table
                          className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                          style={{ tableLayout: "fixed" }}
                        >
                          <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                            {page.map((row) => {
                              prepareRow(row);
                              return (
                                <React.Fragment key={row.id}>
                                  <tr
                                    {...row.getRowProps()}
                                    className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                                  //   onClick={() => openOrderList(row.original.id)}
                                  >
                                    {row.cells.map((cell, index) => (
                                      <td
                                        key={index}
                                        {...cell.getCellProps()}
                                        className={`p-2 text-[#272728] h-1212 text-sm font-normal ${
                                          index < row.cells.length - 1 ? "relative" : ""
                                        } ${
                                          cell?.column?.Header == "Product"
                                            ? "cursor-pointer"
                                            : ""
                                        }`}
                                        //   style={{ width: cell.column.width }} // Match column width
                                      >
                                        {cell.render("Cell")}
                                      </td>
                                    ))}
                                  </tr>
                                </React.Fragment>
                              );
                            })}
                            {page.length === 0 && (
                              <tr>
                                <td colSpan={"100%"}>
                                  <Empty
                                    className="mt-10"
                                    description={t("No data available")}
                                  />
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="">
                        <CustomPagination
                            data={data?.length}
                            pageIndex={pageIndex}
                            pageCount={page?.length}
                            canPreviousPage={pageIndex != 1 ? true : false}
                            canNextPage={data?.length == pageSize ? true : false}
                            gotoPage={(page) => {
                                nextPage(page);
                            }}
                            previousPage={() => {
                                setpageIndex(pageIndex - 1);
                            }}
                            nextPage={() => {
                                setpageIndex(pageIndex + 1);
                            }}
                            pageSize={pageSize}
                            setPageSize={(pageSize) => {
                                setPageSize(pageSize);
                            }}
                        />
                    </div>
          </>
        )}
      </div>
    </>
  );
};

export default ProductPurchaseDetails;





// import React, { useEffect, useMemo, useState } from "react";
// import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
// import "tailwindcss/tailwind.css";
// import CustomPagination from "../../CustomWidgets/CustomPagination";
// import { Empty } from "antd";
// import "../../../styles.css";
// import Vectorsorting from "../../../assets/Vectorsorting.svg";
// import ShimmerLoader from "../../../loading";
// import { useTranslation } from "react-i18next";

// const ProductPurchaseDetails = ({ additionalData, pagination }) => {
//   const { t, i18n } = useTranslation();
//   const [flag, setflag] = useState(false);

//   console.log("TAB:LOADING DATA", additionalData);
  

//   const data = useMemo(
//     () =>
//       additionalData?.status
//         ? additionalData?.all_product
//         : additionalData || [],
//     [additionalData]
//   );

//   useEffect(() => {
//     if (additionalData?.length === 0 && !flag) {
//       const timer = setTimeout(() => {
//         setflag(true);
//       }, 3000);

//       return () => clearTimeout(timer);
//     }
//   }, [additionalData, flag]);

//   const columns = useMemo(
//     () => [
//       {
//         Header: (
//           <div className="text-start justify-start" title={t("Purchase Date")}>
//             {t("Date")}
//           </div>
//         ),
//         accessor: "date",
//         // width: 80,
//         headerClassName: "text-start",
//         Cell: ({ row }) => (
//           <div className="text-start justify-start">{row.original.date}</div>
//         ),
//       },
//       {
//         Header: (
//           <div className="text-start" title={t("Transaction Type")}>
//             {t("Transaction Type")}
//           </div>
//         ),
//         accessor: "transaction_type",
//         // width: 200,
//         headerClassName: "text-start",
//         Cell: ({ row }) => (
//           <div className="text-start">{t(row.original.transaction_type)}</div>
//         ),
//       },
//       {
//         Header: (
//           <div className="text-start" title={t("Transaction ID")}>
//             {t("Transaction ID")}
//           </div>
//         ),
//         accessor: "transaction_id",
//         // width: 100,
//         Cell: ({ row }) => (
//           <div className="text-start">{row.original.transaction_id}</div>
//         ),
//       },
//       {
//         Header: (
//           <div className="text-start" title={t("Sale Price")}>
//             {t("Sale Price")}
//           </div>
//         ),
//         accessor: "sale_price",
//         // width: 120,
//         Cell: ({ row }) => (
//           <div className="text-start">{"EGP"} {row.original.sale_price?.toFixed(2)} </div>
//         ),
//       },
//       {
//         Header: (
//           <div className="text-start" title={t("Purchase Price")}>
//             {t("Purchase Price")} 
//           </div>
//         ),
//         accessor: "purchase_price",
//         // width: 120,
//         Cell: ({ row }) => (
//           <div className="text-start">{"EGP"} {row.original.purchase_price?.toFixed(2)}</div>
//         ),
//       },

//        {
//         Header: (
//           <div className="text-start" title={t("Quantity")}>
//             {t("Quantity")} 
//           </div>
//         ),
//         accessor: "qty",
//         // width: 120,
//         Cell: ({ row }) => (
//           <div className="text-start">{row.original.qty}</div>
//         ),
//       },

//        {
//         Header: (
//           <div className="text-start" title={t("Balance Quantity")}>
//             {t("Balance Quantity")} 
//           </div>
//         ),
//         accessor: "balance_qty",
//         // width: 120,
//         Cell: ({ row }) => (
//           <div className="text-start">{row.original.balance_qty}</div>
//         ),
//       },
//     ],
//     []
//   );

//   const {
//     headerGroups,
//     prepareRow,
//     page,
//     nextPage,
//     setPageSize,
//     state: { pageSize },
//   } = useTable(
//     {
//       columns,
//       data: data,
//       initialState: { pageSize: 10 },
//     },
//     useSortBy,
//     usePagination,
//     useRowSelect
//   );

//   const [pageIndex, setpageIndex] = useState(1);

//   useEffect(() => {
//     const pageDetails = {
//       limit: pageSize,
//       offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
//     };

//     if (pageSize) pagination(pageDetails);
//   }, [pageSize, pageIndex]);

//   return (
//     <>
//       <div
//         className="container flex flex-col mx-auto mt-4"
//         style={{ maxWidth: "100%" }}
//       >
//         {additionalData?.length == 0 && flag == false ? (
//           <div className="h-screen w-[90%] mt-2 ms-4">
//             <ShimmerLoader />
//           </div>
//         ) : (
//           <>
//             {/* Header Table (Fixed) */}
//             <div>
//               <table
//                 className="font-normal mx-auto max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
//                 style={{ tableLayout: "fixed" }}
//               >
//                 <thead>
//                   {headerGroups.map((headerGroup, headerIndex) => {
//                     const { key: headerKey, ...headerGroupProps } =
//                       headerGroup.getHeaderGroupProps();
//                     return (
//                       <tr
//                         key={headerKey}
//                         {...headerGroupProps}
//                         className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
//                       >
//                         {headerGroup.headers.map((column, colIndex) => {
//                           const { key: columnKey, ...columnProps } =
//                             column.getHeaderProps(
//                               column.getSortByToggleProps()
//                             );
//                           return (
//                             <th
//                               key={columnKey}
//                               {...columnProps}
//                               className="py-3 whitespace-nowrap"
//                               style={{ width: column.width }} // Set column width
//                             >
//                               <div className="flex items-start text-sm ms-2">
//                                 {column.render("Header")}
//                                 <span className="">
//                                   {column.isSorted ? (
//                                     column.isSortedDesc ? (
//                                       <img  
//                                         src={Vectorsorting}
//                                         style={{ minHeight: 10, minWidth: 10 }}
//                                         alt="vector"
//                                       />
//                                     ) : (
//                                       <img
//                                         className="rotate-180"
//                                         src={Vectorsorting}
//                                         alt="vector"
//                                       />
//                                     )
//                                   ) : (
//                                     ""
//                                   )}
//                                 </span>
//                               </div>
//                             </th>
//                           );
//                         })}
//                       </tr>
//                     );
//                   })}
//                 </thead>
//               </table>
//             </div>

//             {/* Body Table (Scrollable) */}
//             <div
//               className="scrollbar-none"
//               style={{
//                 overflowY: "auto",
//                 maxHeight: "450px", // Adjust height as needed
//               }}
//             >
//               <table
//                 className="font-normal mx-auto max-w-[100%] sm:w-[97.6%] ms-4 md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden "
//                 style={{ tableLayout: "fixed" }}
//               >
//                 <tbody className="bg-[#F7F9FD] text-start overflow-hidden">
//                   {page.map((row) => {
//                     prepareRow(row);
//                     return (
//                       <React.Fragment key={row.id}>
//                         <tr
//                           {...row.getRowProps()}
//                           className="relative hover:bg-white  transition duration-300 border-b border-gray-300 fixed-row-height"
//                         >
//                           {row.cells.map((cell, index) => (
//                             <td
//                               key={index}
//                               {...cell.getCellProps()}
//                               className={`p-2 text-[#272728] h-1212 text-sm font-normal ${
//                                 index < row.cells.length - 1 ? "relative" : ""
//                               } ${
//                                 cell?.column?.Header == "Product"
//                                   ? "cursor-pointer"
//                                   : ""
//                               }`}
//                             //   style={{ width: cell.column.width }} // Match column width
//                             >
//                               {cell.render("Cell")}
//                             </td>
//                           ))}
//                         </tr>
//                       </React.Fragment>
//                     );
//                   })}
//                   {page.length === 0 && (
//                     <tr>
//                       <td colSpan={"100%"}>
//                         <Empty
//                           className="mt-10"
//                           description={t("No data available")}
//                         />
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//               {/* Pagination */}
//               <div>
//                 <CustomPagination
//                   data={data?.length}
//                   pageIndex={pageIndex}
//                   pageCount={page?.length}
//                   canPreviousPage={pageIndex != 1 ? true : false}
//                   canNextPage={data?.length == pageSize ? true : false}
//                   gotoPage={(page) => {
//                     nextPage(page);
//                   }}
//                   previousPage={() => {
//                     setpageIndex(pageIndex - 1);
//                   }}
//                   nextPage={() => {
//                     setpageIndex(pageIndex + 1);
//                   }}
//                   pageSize={pageSize}
//                   setPageSize={(pageSize) => {
//                     setPageSize(pageSize);
//                   }}
//                 />
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </>
//   );
// };

// export default ProductPurchaseDetails;
